<template>
  <section class="sendAuthCodeSection" :class="{ isPc: !isSp }">
    <TitleText text="メールアドレス認証" />
    <TextGeneral class="text">本人確認のためご入力のメールアドレスに認証コードをお送りいたします。</TextGeneral>
    <InputAreaWithValidation
      v-model="inputMailAddress"
      class="inputMailAddress"
      area-label="メールアドレス"
      input-type="text"
      placeholder="メールアドレスを入力"
      :validation-list="[VALIDATION_LIST.EMPTY, VALIDATION_LIST.EMAIL]"
      @watchValidation="watchMailAddressValidation"
    />
    <ServerErrorArea class="serverErrorArea" :error-type="errorType" :server-error-list="serverErrorList" />
    <div class="termsAndPolicyWrapper">
      <div class="termsAndPolicy">
        <TermsAndPolicy :is-sp-flg="true" />
        <p>に</p>
      </div>
    </div>
    <ButtonTypeCustom
      button-type="button"
      button-text="同意して認証コードを送信する"
      button-color="colorPrimary"
      button-size="sizeLarge"
      :class="{ isDisabled: !canSendRequest }"
      class="sendMailButton"
      @button-clicked="sendMail"
    />
  </section>
</template>

<script>
import qs from 'qs';
import axios from 'axios';
import TitleText from './TitleText.vue';
import TextGeneral from './TextGeneral.vue';
import ServerErrorArea from '../../../common/common/ServerErrorArea.vue';
import InputAreaWithValidation, { VALIDATION_LIST } from '../../../common/common/Input/InputWithLabel.vue';
import ButtonTypeCustom from '../../../common/common/Button/ButtonTypeCustom.vue';
import TermsAndPolicy from '../../../common/common/Text/TermsAndPolicy.vue';
import {
  sendToErrorPage,
  judgeResponseErrorType,
  ERROR_TYPES,
  sendToMaintenancePage,
} from '../../../../helper/_responseError';
import { formatMailAddress } from '../../../../helper/_requestFormatHelper';
import { registerErrorResultMapper } from '../../../common/common/_registerResponseCheck';
import { sendLog } from '../../../../helper/_sendLog';

export default {
  components: {
    TitleText,
    InputAreaWithValidation,
    TermsAndPolicy,
    ButtonTypeCustom,
    TextGeneral,
    ServerErrorArea,
  },
  props: {
    isSpFlg: {
      type: Boolean,
      required: false,
      default: undefined,
    },
    mailAddress: {
      type: Object,
      required: false,
      default: undefined,
    },
  },
  data() {
    return {
      inputMailAddress: '',
      mailAddressValidationError: undefined,
      isMailAddressHasError: undefined,
      postProcessingFlg: false,
      serverErrorList: [],
      errorType: undefined,
    };
  },
  computed: {
    isSp() {
      if (typeof this.isSpFlg === 'boolean') return this.isSpFlg;
      return this.$isSp;
    },
    urlPrefix() {
      return this.$isSp ? 'smp2' : 'net2';
    },
    VALIDATION_LIST() {
      return VALIDATION_LIST;
    },
    canSendRequest() {
      if (this.inputMailAddress === '') return false;
      return true;
    },
  },
  watch: {
    mailAddress: {
      handler(value) {
        if (!value) return;
        if (value.emailAccount && value.emailDomain) {
          this.inputMailAddress = `${value.emailAccount}@${value.emailDomain}`;
        }
      },
      immediate: true,
    },
  },
  methods: {
    watchMailAddressValidation(value) {
      this.isMailAddressHasError = value;
    },
    resetError() {
      this.errorType = undefined;
      this.serverErrorList = [];
    },
    async sendMail(event) {
      if (this.isMailAddressHasError) return;
      if (this.postProcessingFlg) return;

      sendLog(s, event.target, `${trace_p}_send`);
      this.postProcessingFlg = true;

      const mailAddress = formatMailAddress(this.inputMailAddress);

      const param = {
        ...mailAddress,
        resendFlg: '0',
        'org.apache.struts.taglib.html.TOKEN': frontend.csrfToken,
      };
      axios
        .post(`/${this.urlPrefix}/quipMember/register/sendJson/`, qs.stringify(param))
        .then((response) => {
          this.resetError();
          if (!response) throw Error;
          if (!response.data) throw Error;
          if (response.data.resultCode === 0) {
            this.$emit('goto-next', {
              mailAddress,
            });
          } else if (response.data.resultCode === 1) {
            const mappedResponse = registerErrorResultMapper(response);
            if (typeof mappedResponse === 'object') {
              this.serverErrorList = mappedResponse;
            } else {
              this.errorType = mappedResponse;
            }
          } else if (response.data.resultCode === 2) {
            sendToMaintenancePage(this.isSp);
          } else {
            // 異常なresultCode
            throw Error;
          }
        })
        .catch((error) => {
          this.resetError();
          const judgedErrorType = judgeResponseErrorType(error);
          if (judgedErrorType === ERROR_TYPES.OTHER || judgedErrorType === ERROR_TYPES.SYSTEM_ERROR) {
            sendToErrorPage(this.isSp);
          } else {
            this.errorType = judgedErrorType;
          }
        })
        .finally(() => {
          this.postProcessingFlg = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'css/contents/common/global';

.sendAuthCodeSection {
  padding: 24px 20px 40px;

  &.isPc {
    padding: 0;
  }

  .text {
    margin-bottom: 24px;
    font-size: $text-size-paragraph2;
    line-height: $text-line-height-default;
  }

  .serverErrorArea {
    margin-top: 20px;
  }

  .termsAndPolicyWrapper {
    margin-top: 24px;

    .termsAndPolicy {
      font-size: $text-size-paragraph2;
      line-height: $text-line-height-default;
      display: flex;
      align-content: center;
      justify-content: center;
    }
  }

  .sendMailButton {
    margin-top: 12px;

    &.isDisabled {
      background-color: $color-background-primary-third-dark;
      pointer-events: none;
    }
  }
}
</style>
